import React from 'react';

const IconDevto = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-devto">
    <title>Dev.to</title>
    {/* This path is simplified to 24x24 to match the other side-bar icons */}
    <path d="M10 9v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2z" />
    <polyline points="18 9 15 9 15 15 18 15" />
    <line x1="15" y1="12" x2="17" y2="12" />
    <rect x="2" y="3" width="20" height="18" rx="2" ry="2" />
  </svg>
);

export default IconDevto;